import { Typography, styled } from '@mui/material';

const StyledModalTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  fontSize: '24px !important',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '36px',
  [theme.breakpoints.down('lg')]: {
    fontSize: '20px !important',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '15px !important',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
  },
}));

const ModalTitle = ({ children, sx, ...props }) => {
  return (
    <StyledModalTitle variant="h5" sx={{ width: '100%', ...sx }} {...props}>
      {children}
    </StyledModalTitle>
  );
};

export default ModalTitle;
